import React from 'react';
import { connect } from 'react-redux';
import { getOrdersIds } from './../../../actions/firebase/orders';
import { database } from './../../../firebase/firebase-app';
import { listenToOrders, createOrder } from './../../../actions/firebase/orders';

const Sundbox = props => {
  const { customerCode, listenToOrders, createOrder } = props;
  return (
    <div style={{display: 'flex', flexDirection: 'column', padding: '10px'}}>

      <button
        onClick={
          () => {
            getOrdersIds(customerCode)
              .then(val => {
                console.log('orders ', val);
              })
          }
        }
      >Загрузить заказы</button>

      <button
        onClick={
          () => {
            let ordersRef;
            getOrdersIds(customerCode)
              .then(val => {
                const keys = Object.keys(val || {});
                keys.forEach(key => {
                  ordersRef = database.ref('orders/' + customerCode + '/' + key);
                  ordersRef.remove();
                });
              })
          }
        }
      >Удалить заказы</button>

      <button
        onClick={
          () => {
            const requested = {
              '008cc88e-07e0-11e7-97dc-6cae8b4f0d85': 2
            };
            // createOrder('m', undefined, '', requested);
            createOrder({requested})

            // // preorders
            //
            //
            //
            // // machine
            // let newOrder = database.ref('orders/' + customerCode).push();
            // newOrder.set({
            //   id: newOrder.key,
            //   type: 'm',
            //   status: 0,
            //   date: (new Date()).toISOString(),
            //   rDate: (new Date()).toISOString(),
            //   cDate: (new Date()).toISOString(),
            //   comment: 'foo',
            //   commentRepl: 'bar',
            //   userId: '001',
            //   requested: {
            //     'be2781c5-b569-11e6-965b-6cae8b4f0d85': 10
            //   },
            // })
            // // acc
            // newOrder = database.ref('orders/' + customerCode).push();
            // newOrder.set({
            //   id: newOrder.key,
            //   type: 'a',
            //   status: 0,
            //   date: (new Date()).toISOString(),
            //   rDate: (new Date()).toISOString(),
            //   cDate: (new Date()).toISOString(),
            //   comment: 'baz',
            //   commentRepl: 'bam',
            //   userId: '001',
            //   requested: {
            //     '061a1085-b568-11e6-965b-6cae8b4f0d85': 2,
            //     '1182c7a5-b568-11e6-965b-6cae8b4f0d85': 5,
            //     'cdbc4145-b567-11e6-965b-6cae8b4f0d85': 12
            //   },
            // })
            //
            // // confirmed
            //
            // // machine
            // newOrder = database.ref('orders/' + customerCode).push();
            // newOrder.set({
            //   id: newOrder.key,
            //   type: 'm',
            //   status: 1,
            //   date: (new Date()).toISOString(),
            //   rDate: (new Date()).toISOString(),
            //   cDate: (new Date()).toISOString(),
            //   comment: 'foo',
            //   commentRepl: 'bar',
            //   userId: '001',
            //   amount: 1000,
            //   processedBy: 'Чевычелов Денис',
            //   requested: {
            //     'be2781c5-b569-11e6-965b-6cae8b4f0d85': 10
            //   },
            //   items: {
            //     'guid1' : { qty: 1, price: 150, amount: 40, code: 'G99966390', descr: 'Сеялка SP8' },
            //     'guid2' : { qty: 2, price: 20, amount: 40, code: 'G99501600', descr: 'Высевающие диски кукуруза' },
            //     'guid3' : { qty: 8, price: 10, amount: 80, code: 'G99527100', descr: 'Монитор контроля высева V1200' },
            //   }
            // })
            // // acc
            // newOrder = database.ref('orders/' + customerCode).push();
            // newOrder.set({
            //   id: newOrder.key,
            //   type: 'a',
            //   status: 1,
            //   date: (new Date()).toISOString(),
            //   rDate: (new Date()).toISOString(),
            //   cDate: (new Date()).toISOString(),
            //   comment: 'baz',
            //   commentRepl: 'bam',
            //   userId: '001',
            //   amount: 700,
            //   processedBy: 'Чевычелов Денис',
            //   requested: {
            //     '061a1085-b568-11e6-965b-6cae8b4f0d85': 2,
            //     '1182c7a5-b568-11e6-965b-6cae8b4f0d85': 5,
            //     'cdbc4145-b567-11e6-965b-6cae8b4f0d85': 12
            //   },
            //   items: {
            //     '061a1085-b568-11e6-965b-6cae8b4f0d85' : { qty: 2, price: 35, amount: 70, code: 'G99527100', descr: 'Монитор контроля высева V1200' },
            //     '1182c7a5-b568-11e6-965b-6cae8b4f0d85' : { qty: 4, price: 40, amount: 160, code: 'G99501600', descr: 'Высевающие диски кукуруза' },
            //     'cdbc4145-b567-11e6-965b-6cae8b4f0d85' : { qty: 12, price: 60, amount: 720, code: '000000001', descr: 'Интегрированное транспортное устройство сеялки MAESTRA' },
            //   }
            // })

            listenToOrders();

          }
        }
      >Создать заказ</button>


    </div>
  );
}

export default connect(
  state => ({ customerCode: state.customer.code }),
  {listenToOrders, createOrder }
)(Sundbox);



// WEBPACK FOOTER //
// ./src/components/layout/content/sandbox.js